/** The pages that remember what was open in them, so leaving and coming back shows it again. */
export type RememberedPage = 'search' | 'follows'

/** What a page had open: the search session (`s`) and the side-panel startup (`open`). */
export interface RememberedView {
  s?: string
  open?: string
}

const key = (page: RememberedPage, investorId: string) => `investor-view:${page}:${investorId}`

/**
 * Written from the page's own navigation, not from an effect: a route's beforeLoad runs before effects, so a
 * value that is only cleared later would be restored. Keys present in the patch are set, or cleared when undefined.
 */
export function rememberView(
  page: RememberedPage,
  investorId: string,
  patch: RememberedView
): void {
  try {
    const next = { ...lastView(page, investorId), ...patch }
    window.sessionStorage.setItem(key(page, investorId), JSON.stringify(next))
  } catch {
    // Storage can be blocked: the page then opens as it did before.
  }
}

export function lastView(page: RememberedPage, investorId: string): RememberedView {
  try {
    const raw = window.sessionStorage.getItem(key(page, investorId))
    return raw ? (JSON.parse(raw) as RememberedView) : {}
  } catch {
    return {}
  }
}
